import { useRef } from 'react';

import { BryntumSchedulerPro } from '@bryntum/gantt-react';

import { ColorByMode, ComparisonMode } from 'components/common/bryntumScheduler/types';

export type SchedulerControls = {
    isShowLabels: boolean;
    comparisonMode: ComparisonMode;
    colorByMode: ColorByMode;
};

export function useSchedulerControls(initial: Partial<SchedulerControls> = {}) {
    const controlsRef = useRef<SchedulerControls>({
        isShowLabels: true,
        comparisonMode: 'none',
        colorByMode: 'STATUS',
        ...initial,
    });
    const schedulerInstanceRef = useRef<BryntumSchedulerPro>(null);

    const update = (patch: Partial<SchedulerControls>) => {
        Object.assign(controlsRef.current, patch);
        schedulerInstanceRef.current?.instance?.refreshRows();
    };

    return { controlsRef, schedulerInstanceRef, update };
}
